<template>
  <div v-bind:class="dialogClassName">
    <div class="dialog-overlay"></div>
    <div class="dialog-content img-slider" v-if="hasImages">
      <a class="close" v-on:click="close">
        <i class="lni lni-close"></i>
      </a>
      <!-- <template v-for="image in images">
        <input type="radio" id="trigger1" name="slider" />
        <label for="trigger1"></label>
        <div class="slide bg1">
          <img
            src="https://images.unsplash.com/photo-1515378960530-7c0da6231fb1?ixlib=rb-1.2.1&amp;w=1000&amp;q=80"
            alt
          />
        </div>
      </template>-->
      <template v-for="image in images">
        <input
          type="radio"
          v-bind:id="image.url"
          name="slider"
          v-model="currentMiddleImage"
          autofocus
          v-bind:key="`radio-${image.url}`"
          v-bind:value="image.url"
        />
        <label v-bind:for="image.url" v-bind:key="`label-${image.url}`"></label>
        <div class="slide bg2" v-bind:key="`div-${image.url}`">
          <img v-bind:src="image.url" alt />
        </div>
      </template>

      <!-- <input type="radio" id="trigger3" name="slider" checked />
      <label for="trigger3"></label>
      <div class="slide bg3">
        <img
          src="https://images.unsplash.com/photo-1499750310107-5fef28a66643?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1400&q=60"
          alt
        />
      </div>
      <input type="radio" id="trigger3" name="slider" />
      <label for="trigger3"></label>
      <div class="slide bg3">
        <img
          src="https://images.unsplash.com/photo-1499750310107-5fef28a66643?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1400&q=60"
          alt
        />
      </div>-->
    </div>
  </div>
</template>
<script>
export default {
  data: () => {
    return {
      selectedUrl: ""
    };
  },
  computed: {
    dialogClassName() {
      return `dialog ${this.$store.getters.dialogImageLectureClass}`;
    },
    hasImages() {
      return !!this.$store.getters.images;
    },
    images() {
      return this.hasImages ? this.$store.getters.images : [];
    },
    dialogImageCurrentUrl() {
      return this.$store.getters.dialogImageCurrentUrl;
    },
    currentImage() {
      const selectedImage = (this.$store.getters.images || []).filter(
        image => image.selected
      )[0];
      return selectedImage ? selectedImage.url : "";
    },
    currentMiddleImage() {
      return this.$store.state.currentImage;
    }
  },
  methods: {
    close() {
      this.$store.commit("setDialogImageLectureClass", { className: "close" });
      setTimeout(() => {
        this.$store.commit("setDialogImageLectureClass", { className: "" });
      }, 500);
    },
    changeImage(url) {
      this.$store.commit("updateImageSelected", url);
    }
  },
  mounted() {
    console.log("this.dialogImageCurrentUrl : ", this.dialogImageCurrentUrl);
    console.log("this.currentImage : ", this.currentImage);
    this.selectedUrl = this.currentImage;
  }
};
</script>